<template>
  <div class="announcement">
    <div class="white-overlay">
      <div class="container-fluid">
        <header class="stdenis-header pd-t-30">
          <h2>Upcoming Programs</h2>
          <p>To keep the fire of love of Christ burning in the heart of all our Parishioners, we engage them with the following activities.</p>
        </header>
        <div class="row">
          <div
                  class="col-lg-4 col-md-12 announcement-container"
                  v-for="listitems in upcomingprogramList"
                  :key="listitems.title"
          >
            <div class="announcement-box">
              <template v-if="listitems.image !== ''">
                <img :src="listitems.image" alt class="img-fluid" />
              </template>
              <template v-else>
                <img src="../assets/logo.jpeg" alt class="img-fluid" />
              </template>
              <div class="program-date text-center">
                <i class="icon ion-md-calendar"></i>
                <h3>{{listitems.programDateTime.toDate().getDate()}}</h3>
                <p>
                  {{getMonthName(listitems.programDateTime.toDate().getUTCMonth())}}
                  <span
                          style="color:#fff"
                  >&nbsp; {{listitems.programDateTime.toDate().getFullYear()}}</span>
                </p>
              </div>
              <h3 class="announcement-header">{{listitems.title}}</h3>
              <p class="description">{{listitems.body}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firestoreDB } from "../config/firebase";

  const upcomingprogramRef = firestoreDB.collection("upcomingPrograms");

  export default {
    name: "UpcomingPrograms",
    data() {
      return {
        upcomingprogramList: [],
        months: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ]
      };
    },
    methods: {
      populateUpcomingProgram() {
        upcomingprogramRef.get().then(docSnapshots => {
          if (!docSnapshots.empty) {
            docSnapshots.forEach(doc => {
              if (doc.exists) {
                this.upcomingprogramList.push(doc.data());
              }
            });
          }
        });
      },
      getMonthName(month) {
        return this.months[month];
      }
    },
    created() {
      window.scrollTo(0, 0);
      this.populateUpcomingProgram();
    }
  };
</script>

<style scoped>
  .announcement {
    background-color: #fff;
  }
  .announcement-container {
    margin-bottom: 20px;
  }
  .announcement-box {
    background: #fff;
    position: relative;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
    z-index: 2;
    transition: all 0.3s ease 0s;
  }
  .announcement-box:hover {
    box-shadow: 0px 60px 60px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 100;
    transform: translate(0, -10px);
  }
  .announcement-box img {
    width: 100%;
  }
  .announcement-box .program-date {
    position: absolute;
    width: 100px;
    height: 120px;
    background: #e12993;
    top: 0;
    left: 0;
    padding: 10px;
  }
  .announcement-box .program-date i,
  .announcement-box .program-date h3 {
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 0;
  }
  .announcement-box .announcement-header {
    text-align: center;
    text-transform: capitalize;
    margin-top: 10px;
  }
  .announcement-box .program-date p {
    font-size: 15px;
    color: #fff;
    text-align: center;
  }
  .announcement-box .description {
    padding: 10px;
  }
</style>